import { render } from "./lessonShare.vue?vue&type=template&id=54ce360f&scoped=true"
import script from "./lessonShare.vue?vue&type=script&lang=js"
export * from "./lessonShare.vue?vue&type=script&lang=js"

import "./lessonShare.vue?vue&type=style&index=0&id=54ce360f&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ce360f"]])

export default __exports__